import styled from 'styled-components';

import ModalLayout from '@/layouts/ModalLayout';

export const ModalDialogContainer = styled(ModalLayout)`
  width: 480px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  span {
    margin-bottom: 16px;
  }

  p {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 24px;
    text-align: center;
  }

  button {
    width: 299px;

    + button {
      margin-top: 16px;
    }
  }
`;
